import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gfu-info-hero gfu-info-hero--guide _jc-c" }
const _hoisted_2 = { class: "gfu-info-hero__content" }
const _hoisted_3 = { class: "gfu-hd gfu-hd--d2 gfu-hd--decorative _tc--accent-inverse _mb-4" }
const _hoisted_4 = { class: "_pos-r js-main-content" }
const _hoisted_5 = { class: "gfu-layout-wrapper gfu-layout-wrapper--narrow _py-6 _flexcol _gap-6" }
const _hoisted_6 = { class: "_tac" }
const _hoisted_7 = { class: "gfu-crowdfunding-guide__content" }
const _hoisted_8 = { class: "gfu-media-description__body" }
const _hoisted_9 = ["id"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "gfu-media-description__aside" }
const _hoisted_12 = { class: "gfu-crowdfunding-guide__content" }
const _hoisted_13 = { class: "gfu-media-description__body" }
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "_mt-3" }
const _hoisted_16 = { class: "gfu-media-description__aside" }
const _hoisted_17 = ["id"]
const _hoisted_18 = { class: "gfu-icon--hd" }
const _hoisted_19 = { class: "_mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_footer_navigation = _resolveComponent("footer-navigation")
  const _component_base_button = _resolveComponent("base-button")
  const _component_box = _resolveComponent("box")
  const _component_base_title = _resolveComponent("base-title")
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_table_of_contents = _resolveComponent("table-of-contents")
  const _component_crowdfunding_glossary_modal = _resolveComponent("crowdfunding-glossary-modal")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_footer_navigation, {
      "current-page": _ctx.Resources.Layout.CrowdfundingGuideLink
    }, null, 8 /* PROPS */, ["current-page"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "gfu-info-hero__cover" }, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.Resources.CrowdfundingGuide.PageHeader), 1 /* TEXT */),
        _cache[0] || (_cache[0] = _createTextVNode(" Wondering what crowdfunding is all about or how it actually works? ", -1 /* CACHED */)),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */)),
        _cache[2] || (_cache[2] = _createTextVNode(" Here's a simple guide to help you understand the basics. ", -1 /* CACHED */))
      ])
    ]),
    _createElementVNode("main", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_box, {
          huge: "",
          class: "_flexcol _gap-6"
        }, {
          default: _withCtx(() => [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "_flexcol _gap-4" }, [
              _createElementVNode("div", null, [
                _createElementVNode("strong", { class: "_tc--dark" }, " Crowdfunding is all about turning cool ideas into reality with the help of a supportive community. Instead of buying something that’s already on the shelf, you’re backing a project before it’s made – which means it can take a little time for the product to be created and delivered. ")
              ]),
              _createElementVNode("div", null, " At its heart, crowdfunding is a meeting place for creators with bold ideas and people excited to see them come to life. When you support a project, you’re not just ordering a product – you’re joining the journey. You’ll often get early access, one-of-a-kind rewards, and the satisfaction of knowing you played a role in bringing something new into the world. "),
              _createElementVNode("div", null, " This guide will walk you through how crowdfunding works, so you'll know what to expect before jumping in. ")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_base_button, {
                shape: "soft",
                theme: "accent",
                onClick: $options.onGlossaryOpen
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("View crowdfunding glossary", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ])
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_base_title, {
            as: "h3",
            level: "h2"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Campaign stages", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }),
          _cache[7] || (_cache[7] = _createElementVNode("div", null, " Crowdfunding projects move through several stages, each with its own role and opportunities. Knowing what happens when will help you follow along, decide how to take part, and understand when things like pledging or sharing your shipping details come into play. ", -1 /* CACHED */))
        ]),
        _createVNode(_component_box, {
          content: true,
          class: "gfu-box--content _foh gfu-bt gfu-bt--b1 gfu-crowdfunding-guide__box"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.stages, (section) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: section.sectionID,
                  class: _normalizeClass([{'gfu-media-description--reverse': section.isReversed}, 'gfu-media-description _mb-6'])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", {
                      id: section.sectionID,
                      ref_for: true,
                      ref: section.sectionID,
                      class: "gfu-hd gfu-hd--h2 gfu-heading--top-divider"
                    }, _toDisplayString(section.header), 9 /* TEXT, PROPS */, _hoisted_9),
                    _createElementVNode("div", {
                      class: "_mt-3",
                      innerHTML: section.paragraph
                    }, null, 8 /* PROPS */, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_themed_image, {
                      src: section.image,
                      alt: section.header
                    }, null, 8 /* PROPS */, ["src", "alt"])
                  ])
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_base_title, {
          as: "h3",
          level: "h2"
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode("Concept Explanation", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_box, {
          content: true,
          class: "gfu-box--content _foh gfu-bt gfu-bt--b1 gfu-crowdfunding-guide__box"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.crowdfundingGuideMediaModel, (section) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: section.sectionID,
                  class: _normalizeClass([{'gfu-media-description--reverse': section.isReversed}, 'gfu-media-description _mb-6'])
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h3", {
                      id: section.sectionID,
                      ref_for: true,
                      ref: section.sectionID,
                      class: "gfu-hd gfu-hd--h2 gfu-heading--top-divider"
                    }, _toDisplayString(section.header), 9 /* TEXT, PROPS */, _hoisted_14),
                    _createElementVNode("p", _hoisted_15, _toDisplayString(section.paragraph), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_themed_image, {
                      src: section.image,
                      alt: section.header
                    }, null, 8 /* PROPS */, ["src", "alt"])
                  ])
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.stepsExplanationModel, (section) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: section.sectionID,
                  class: "_mt-4"
                }, [
                  _createElementVNode("h3", {
                    id: section.sectionID,
                    ref_for: true,
                    ref: section.sectionID,
                    class: "gfu-hd gfu-hd--h3 _ttu _flex"
                  }, [
                    _createVNode(_component_base_icon, {
                      name: section.icon,
                      "icon-namespace": section.iconNamespace,
                      class: "_mr-1 gfu-icon--big _tc--accent"
                    }, null, 8 /* PROPS */, ["name", "icon-namespace"]),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(section.header), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_17),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(section.paragraph), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createVNode(_component_table_of_contents),
      _createVNode(_component_crowdfunding_glossary_modal, {
        "is-visible": _ctx.isGlossaryVisible,
        onClose: $options.onGlossaryClose
      }, null, 8 /* PROPS */, ["is-visible", "onClose"])
    ])
  ]))
}